<template lang="pug">
  v-container.pa-5(fluid grid-list-md fill-height)
    d-add(ref="dialogAdd" :customer-id="customerId" :budget-id="budgetId" @complele="doLoadCampaigns(true)")

    v-layout(column)
      v-flex.mb-3
        v-layout(row)
          v-flex(xs4 d-flex align-center)
            v-icon.pr-2(size="40") autorenew
            v-flex
              .headline Campaign
              .overline {{ customerId }}
          v-flex(d-flex justify-end align-center)
            v-btn.mr-2(@click="doLoadCampaigns(true) && doLoadBudgets(true)") Refersh
            v-btn(:disabled="!customerId || !budgetId" @click="$refs.dialogAdd.show()") Add Campaign

      v-flex(fill-height)
        v-card
          v-data-table(
            :headers="headers"
            :items="items"
            :loading="loading"
            :items-per-page="15"
            @click:row="onItemClick"
          )
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import DAdd from './dialogs/AddCampaign'

export default {
  components: {
    DAdd
  },
  data () {
    return {
      customerId: null,
      budgetId: null,
      loading: false,
      items: [],
      headers: [
        { text: 'ID', value: 'campaign.id' },
        { text: 'Name', value: 'campaign.name' },
        { text: 'Status', value: 'campaign.status' },
        { text: 'Start', value: 'campaign.startDate' },
        { text: 'End', value: 'campaign.endDate' }
      ]
    }
  },
  async mounted () {
    this.customerId = this.$route.params.customer
    this.doLoadCampaigns()
    this.doLoadBudgets()
  },
  computed: {
    ...mapGetters({
      getBudgetId: 'ads/budgetDefaultId'
    })
  },
  methods: {
    ...mapActions({
      loadCampaigns: 'ads/loadCampaigns',
      loadBudgets: 'ads/loadBudgets'
    }),
    async doLoadCampaigns (reload = false) {
      const params = {
        customerId: this.customerId,
        reload: reload
      }
      this.loading = true
      this.items = await this.loadCampaigns(params)
      this.loading = false
    },
    async doLoadBudgets (reload = false) {
      const params = {
        customerId: this.customerId,
        reload: reload
      }
      await this.loadBudgets(params)

      this.budgetId = this.getBudgetId(this.customerId)
      if (!this.budgetId) {
        await this.$store.dispatch('ads/createBudgetDefault', { customerId: this.customerId })
        this.doLoadBudgets(true)
      }
    },
    onItemClick (item) {
      const id = item.campaign.id
      this.$router.push({ name: 'google-ads-ad-group', params: { customer: this.customerId, campaign: id } })
    }
  }
}
</script>
